export var getParentNode = function (target) { return target.parentNode; };
